import React, { Suspense } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { locale, loadMessages } from "devextreme/localization";
import ruMessages from "devextreme/localization/messages/ru.json";
import history from "../../constants/history";
import { Router, Route, Switch } from "react-router-dom";
import cookie from "js-cookie";
import { AppRoute, AppRoutes } from "../../routes/appRoutes";
import { AppStateType } from "../../reducers/store";
import { readOrders, setOrders } from "../../actions/usersActions";
import "devextreme-intl";
import moment from "moment";
import "moment/locale/ru";
import Preloader from "../common/Preloader";
import "../../styles/home.scss";
import "../../styles/admin.scss";
import "../../styles/login.scss";
import { IOrder } from "../../entities/Main";
import { requestLogin } from "../../actions/authActions";

moment.locale("ru");

const { v4: uuidv4 } = require("uuid");

type MapStateToPropsType = {
  token: string;
  isCookiesAccepted: boolean;
};

type MapDispatchPropsType = {
  readOrders: () => void;
  setOrders: (orders: Array<IOrder>) => void;
  doLogin: (
    login: string,
    password: string,
    reload: boolean,
    token?: string
  ) => void;
};

type OwnPropsType = {};

type PropsType = MapStateToPropsType & MapDispatchPropsType & OwnPropsType;

// const queryString = require("query-string");
// let parsed = queryString.parse(window.location.search);

class App extends React.Component<PropsType> {
  constructor(props: PropsType) {
    super(props);
    loadMessages(ruMessages);
    locale(navigator.language);
  }

  componentDidMount = () => {
    if (!cookie.get("uuid")) cookie.set("uuid", uuidv4(), { expires: 365 });

    if (!cookie.get("resetTrash")) {
      cookie.set("resetTrash", "1", { expires: 365 });
      this.props.setOrders([]);
    }

    this.props.readOrders();
  };

  render() {
    return (
      <Suspense fallback={<Preloader />}>
        <Router history={history}>
          <Switch>
            {AppRoutes.map((route: AppRoute) => (
              <Route
                exact={route.exact}
                path={route.path}
                component={route.component}
                key={route.path}
              />
            ))}
          </Switch>
        </Router>
      </Suspense>
    );
  }
}

const mapStateToProps = (state: AppStateType) => ({
  token: state.auth.token,
  isCookiesAccepted: state.app.isCookiesAccepted,
});

export default compose(
  connect<
    MapStateToPropsType,
    MapDispatchPropsType,
    OwnPropsType,
    AppStateType
  >(mapStateToProps, {
    readOrders: readOrders,
    setOrders: setOrders,
    doLogin: requestLogin,
  })
)(App);
